const apiPaths = {
  LOGIN_TOKEN: "api/gw/oauth/token",
  REFREST_TOKEN: "api/gw/oauth/token/refreshToken",
  USER_DETAILS: "api/gw/user/getCurrentUserDetails",
  PROFILE_HUB: {
    ME: "api/gw/profile/v1/me",
    UPDATE_IDENTITY: "api/gw/profile/v1/me"
  },
  LOGOUT: "api/gw/user/logout",
  GET_MENUITEMS: "api/user/getMenuItems",
  UPDATE_APPSCODE: "api/gw/user/updateAppsCode",
  VERIFY_EMAIL: "admin/login/verifyemail",
  PROVISION_STATUS: (registrationId) =>
  `admin/registration/provision-status/${encodeURIComponent(registrationId)}`,
  REGISTER_ACCOUNT: "admin/accn-registration/create",
  CHECK_EMAIL_EXISTSORNOT: "admin/accn-registration/check-email",
  CHECK_HOSPITAL_NAME: "admin/accn-registration/check-hospital-name",
  REGISTRATION_OPTIONS: "admin/accn-registration/options",
  RESET_PASSWORD: "admin/accn-registration/reset-password",
  TENANT_RESOLVE: "admin/public/tenant/resolve",
  TENANT_BRANDING: "admin/public/tenant/branding",
  TENANT_SLUG_AVAILABILITY: "admin/public/tenant/slug/availability",
  TENANT_LOGO: "admin/public/tenant/logo",
  UPDATE_PASSWORD: "api/gw/user/passwordChange",
  GENERATE_2FA: "api/gw/2fa/generate",
  VERIFY_2FA: "api/gw/2fa/verify",
  DASHBOARD: {
    GET_MACHINE_COUNT: "inv/dashboard/counts",
    GET_ACTIVE_USERS: "inv/dashboard/getActiveUsers/count",
    GET_LOCATION_WISE_ASSETS: "inv/dashboard/getLocationWiseAssets",
    GET_AUDIT_SUMMARY: "inv/dashboard/auditSummaries"
  },
  ADMIN_PORTAL: {
    DROPDOWN_SERVICE: {
      GET_APPS_CODE: "admin/dropdowns/getAppsCodes",
      GET_APPS_DESC: "admin/dropdowns/getAppsDesc",
      GET_MAIL_CONFIG: "admin/dropdowns/getMailConfig",
      GET_ROLES: "admin/dropdowns/getRoles",
      GET_ROLES_BY_APPSCODE: "admin/dropdowns/getRoleAppsCode",
      GET_ROLES_BY_ROLEID: "admin/dropdowns/getRolesByRoleName",
      GET_URI_TYPES: "admin/dropdowns/getUriTypes",
      GET_WEEKS: "admin/dropdowns/getTimesheetWeeks",
      GET_USERS_BY_APPSCODE: "admin/dropdowns/getUsers",
      GET_LOCATIONS_BY_APPSCODE: "admin/dropdowns/getOfficeLocations",
      GET_USERS_BY_ROLE: "admin/dropdowns/getUsersByRole",
      GET_COUNTRIES: "admin/dropdowns/getCountries",
      GET_ACCN_TYPES: "admin/dropdowns/getAccountTypes",
      GET_STATES: "admin/dropdowns/getStates"
    },
    ACCESS_CONTROL: {
      CATALOG: "admin/access-control/catalog",
      POST_ACCESS_CONTROL: "admin/access-control/create/save",
      LIST_VIEW: "admin/access-control/list/json"
    },
    CRM: {
      LEADS: "admin/crm/leads",
      LEAD: (id) => `admin/crm/leads/${id}`,
      ASSIGN: (id) => `admin/crm/leads/${id}/assign`,
      ACTIVITIES: (id) => `admin/crm/leads/${id}/activities`,
      DASHBOARD: "admin/crm/dashboard/summary",
      FOLLOW_UPS: "admin/crm/follow-ups"
    },
    ACCOUNTS: {
      GET_LIST: "admin/manageAccount",
      UPDATE_STATUS: "admin/manageAccount/updateStatus/",
      CREATE: "admin/manageAccount/create",
      UPDATE: "admin/manageAccount/update",
      GET_BY_ID: "admin/manageAccount/getById"
    },
    HOSPITAL_SETUP: {
      STATUS: "admin/hospital-setup/status",
      REFRESH: "admin/hospital-setup/refresh",
      STEP: "admin/hospital-setup/step",
      COMPLETE: "admin/hospital-setup/complete",
      RESTART: "admin/hospital-setup/restart"
    },
    WHATSAPP_WALLET: {
      BALANCE: "admin/api/whatsapp-wallet",
      LEDGER: "admin/api/whatsapp-wallet/ledger",
      /** Base URL for C1DataTable (appends /list/json like manage-roles). */
      LEDGER_LIST: "admin/api/whatsapp-wallet/ledger",
      TOPUP_ORDER: "admin/api/whatsapp-wallet/topup/order",
      TOPUP_PREVIEW: "admin/api/whatsapp-wallet/topup/preview",
      TOPUP_CONFIRM: "admin/api/whatsapp-wallet/topup/confirm",
      TOPUP_STATUS: (orderId) => `admin/api/whatsapp-wallet/topup/status/${orderId}`
    },
    WHATSAPP_CAMPAIGNS: {
      BASE: "admin/api/whatsapp-campaigns",
      LIST: "admin/api/whatsapp-campaigns",
      REPORTS: "admin/api/whatsapp-campaigns/reports",
      TEMPLATES: "admin/api/whatsapp-campaigns/templates",
      DETAIL: (id) => `admin/api/whatsapp-campaigns/${id}`,
      RECONCILIATION: (id) => `admin/api/whatsapp-campaigns/${id}/reconciliation`,
      RECIPIENTS: (id) => `admin/api/whatsapp-campaigns/${id}/recipients`,
      MESSAGES: (id) => `admin/api/whatsapp-campaigns/${id}/messages`,
      MEDIA: (id) => `admin/api/whatsapp-campaigns/${id}/media`,
      PREVIEW: (id) => `admin/api/whatsapp-campaigns/${id}/audience/preview`,
      COST: (id) => `admin/api/whatsapp-campaigns/${id}/cost`,
      VALIDATE: (id) => `admin/api/whatsapp-campaigns/${id}/validate-for-reservation`,
      TEST: (id) => `admin/api/whatsapp-campaigns/${id}/test`,
      RESERVE: (id) => `admin/api/whatsapp-campaigns/${id}/reserve`,
      CONFIRM: (id) => `admin/api/whatsapp-campaigns/${id}/confirm`,
      SEND: (id) => `admin/api/whatsapp-campaigns/${id}/send`
    },
    WHATSAPP_CAMPAIGN_PRICING: {
      BASE: "admin/api/whatsapp-campaign-pricing"
    },
    WHATSAPP_MESSAGE_PRICING: {
      BASE: "admin/api/whatsapp-message-pricing"
    },
    WHATSAPP_PARTNER_TEMPLATES: {
      REVIEW: "admin/api/whatsapp-partner/templates/review",
      SYNC: "admin/api/whatsapp-partner/templates/sync",
      BIND: "admin/api/whatsapp-partner/templates/bind",
      SUBMIT_MISSING: "admin/api/whatsapp-partner/templates/submit-missing",
      MARKETING_META: "admin/api/whatsapp-partner/templates/marketing/meta",
      MARKETING_LIST: "admin/api/whatsapp-partner/templates/marketing",
      MARKETING_SUBMIT: "admin/api/whatsapp-partner/templates/marketing",
      MARKETING_REFRESH: (id) => `admin/api/whatsapp-partner/templates/marketing/${id}/refresh`
    },
    WHATSAPP_ONBOARDING: {
      STATUS: "admin/api/whatsapp-onboarding",
      START: "admin/api/whatsapp-onboarding/start",
      COMPLETE: "admin/api/whatsapp-onboarding/complete",
      USE_CHERITTO: "admin/api/whatsapp-onboarding/use-cheritto",
      REFRESH: "admin/api/whatsapp-onboarding/refresh",
      SYNC: "admin/api/whatsapp-onboarding/sync",
      REQUEST_REMOVAL: "admin/api/whatsapp-onboarding/request-removal",
      CANCEL_REMOVAL: "admin/api/whatsapp-onboarding/cancel-removal",
      CONFIRM_RELEASE: "admin/api/whatsapp-onboarding/confirm-release",
      RETRY_OPS_EMAIL: "admin/api/whatsapp-onboarding/retry-ops-email"
    },
    WHATSAPP_BUSINESS_SETUP: {
      STATUS: "admin/api/whatsapp-business-setup",
      DRAFT: "admin/api/whatsapp-business-setup/draft",
      SUBMIT: "admin/api/whatsapp-business-setup/submit",
      START_EMBEDDED_SIGNUP: "admin/api/whatsapp-business-setup/start-embedded-signup",
      REFRESH_PROVIDER: "admin/api/whatsapp-business-setup/refresh-provider",
      SYNC_DISPLAY_NAME: "admin/api/whatsapp-business-setup/sync-display-name",
      DOCUMENTS: "admin/api/whatsapp-business-setup/documents",
      DOCUMENT: (id) => `admin/api/whatsapp-business-setup/documents/${id}`,
      RESPOND: (id) => `admin/api/whatsapp-business-setup/information-requests/${id}/respond`
    },
    MOBILE_APP_UPDATE: {
      BASE: "admin/api/mobile-app-update"
    },
    WHATSAPP_INBOX: {
      CONVERSATIONS: "admin/api/whatsapp-inbox/conversations",
      CONVERSATION: (id) => `admin/api/whatsapp-inbox/conversations/${id}`,
      MESSAGES: (id) => `admin/api/whatsapp-inbox/conversations/${id}/messages`,
      REPLY: (id) => `admin/api/whatsapp-inbox/conversations/${id}/reply`
    },
    SAAS_SUBSCRIPTIONS: {
      PLANS: "admin/api/saas-subscriptions/plans",
      BILLING_PROFILE: "admin/api/saas-subscriptions/billing-profile",
      ORDERS: "admin/api/saas-subscriptions/orders",
      RECONCILE_ORDER: (orderId) =>
        `admin/api/saas-subscriptions/orders/${encodeURIComponent(orderId)}/reconcile`,
      ABANDON_ORDER: (orderId) =>
        `admin/api/saas-subscriptions/orders/${encodeURIComponent(orderId)}/abandon`,
      CONFIRM: "admin/api/saas-subscriptions/confirm",
      STATUS: (orderId) => `admin/api/saas-subscriptions/status/${orderId}`,
      CURRENT: "admin/api/saas-subscriptions/current",
      PAYMENTS: "admin/api/saas-subscriptions/payments",
      INVOICE_PDF: (invoiceId) =>
        `admin/api/saas-subscriptions/invoices/${encodeURIComponent(invoiceId)}/pdf`,
      INVOICE_RETRY: (invoiceId) =>
        `admin/api/saas-subscriptions/invoices/${encodeURIComponent(invoiceId)}/retry`,
      ADMIN_PLANS: "admin/api/saas-subscriptions/admin/plans",
      ADMIN_PLAN: (planId) => `admin/api/saas-subscriptions/admin/plans/${encodeURIComponent(planId)}`,
      ADMIN_PLAN_ACTIVATE: (planId) =>
        `admin/api/saas-subscriptions/admin/plans/${encodeURIComponent(planId)}/activate`,
      ADMIN_PLAN_DEACTIVATE: (planId) =>
        `admin/api/saas-subscriptions/admin/plans/${encodeURIComponent(planId)}/deactivate`,
      RECURRING: "admin/api/saas-subscriptions/recurring",
      RECURRING_STATUS: (subscriptionId) =>
        `admin/api/saas-subscriptions/recurring/${subscriptionId}`,
      RECURRING_AUTH_SUBMITTED: (subscriptionId) =>
        `admin/api/saas-subscriptions/recurring/${subscriptionId}/authorization-submitted`,
      RECURRING_CANCEL: (subscriptionId) =>
        `admin/api/saas-subscriptions/recurring/${subscriptionId}/cancel`,
      RECURRING_PAUSE: (subscriptionId) =>
        `admin/api/saas-subscriptions/recurring/${subscriptionId}/pause`,
      RECURRING_RESUME: (subscriptionId) =>
        `admin/api/saas-subscriptions/recurring/${subscriptionId}/resume`,
      OPS: {
        SUMMARY: "admin/api/saas-subscriptions/ops/summary",
        SUBSCRIPTION: (id) => `admin/api/saas-subscriptions/ops/subscriptions/${id}`,
        RECON_REQUIRED: "admin/api/saas-subscriptions/ops/attention/reconciliation-required",
        UNRESOLVED_CREATES: "admin/api/saas-subscriptions/ops/attention/unresolved-creates",
        PAYMENT_FAILURES: "admin/api/saas-subscriptions/ops/attention/payment-failures",
        RECENT_RECOVERIES: "admin/api/saas-subscriptions/ops/attention/recent-recoveries",
        WEBHOOK_EVENTS: "admin/api/saas-subscriptions/ops/webhook-events",
        WEBHOOK_REPROCESS: (eventId) =>
          `admin/api/saas-subscriptions/ops/webhook-events/${eventId}/reprocess`,
        RECONCILE: (id) => `admin/api/saas-subscriptions/ops/reconcile/${id}`,
        ORDER_RECONCILE: (orderId) =>
          `admin/api/saas-subscriptions/ops/orders/${encodeURIComponent(orderId)}/reconcile`,
        ORDER_ABANDON: (orderId) =>
          `admin/api/saas-subscriptions/ops/orders/${encodeURIComponent(orderId)}/abandon`,
        RECONCILE_BATCH: "admin/api/saas-subscriptions/ops/reconcile-batch",
      },
    },
    MANAGE_ROLES: {
      GET_ROLE_LIST: "admin/manageRole",
      ROLE_SUMMARY: "admin/manageRole/summary",
      UPDATE_STATUS: "admin/manageRole/updateStatus/",
      CREATE: "admin/manageRole/create",
      UPDATE: "admin/manageRole/update",
      GET_BY_ID: "admin/manageRole/getById"
    },
    MANAGE_URI: {
      GET_URI_LIST: "admin/uri",
      UPDATE_STATUS: "admin/uri/updateStatus/",
      CREATE: "admin/uri/create",
      UPDATE: "admin/uri/update",
      GET_BY_ID: "admin/uri/getById"
    },
    USER_ROLES: {
      GET_ROLE_LIST: "admin/userRole",
      UPDATE_STATUS: "admin/userRole/updateStatus/",
      CREATE: "admin/userRole/create",
      UPDATE: "admin/userRole/update",
      GET_BY_ID: "admin/userRole/getById",
      DELETE: "admin/userRole"
    },
    MAIL_CONFIG: {
      GET_BY_LIST: "admin/mail-config",
      UPDATE_STATUS: "admin/mail-config/updateStatus/",
      CREATE: "admin/mail-config/create",
      UPDATE: "admin/mail-config/update",
      GET_BY_ID: "admin/mail-config/getById"
    },
    AUTH_CONFIG: {
      GET_BY_LIST: "admin/auth-config",
      UPDATE_STATUS: "admin/auth-config/updateStatus/",
      CREATE: "admin/auth-config/create",
      UPDATE: "admin/auth-config/update",
      GET_BY_ID: "admin/auth-config/getById"
    },
    MAIL_SERVER_CONFIG: {
      GET_BY_LIST: "admin/mail-server-config",
      UPDATE_STATUS: "admin/mail-server-config/updateStatus/",
      CREATE: "admin/mail-server-config/create",
      UPDATE: "admin/mail-server-config/update",
      GET_BY_ID: "admin/mail-server-config/getById",
      TEST_MAIL: "admin/mail-server-config/send-mail"
    },
    MANAGE_USERS: {
      UPLOAD_DP: "admin/users/upload/dp",
      SEARCH: "admin/users/search"
    },
    DOCTOR_LINKS: {
      PREVIEW: "admin/doctor-links/reconciliation/preview",
      EXECUTE: "admin/doctor-links/reconciliation/execute",
      INTEGRITY: "admin/doctor-links/integrity",
      DIAGNOSTICS: "admin/doctor-links/diagnostics"
    }
  },
  EMPLOYEE_MANAGEMENT_PORTAL: {
    DROPDOWN_SERVICE: {
      GET_DEPARTMENTS: "ems/dropdowns/getDepartments",
      GET_LEAVE_TYPES: "ems/dropdowns/getLeaveTypes"
    },
    DASHBOARD: {
      LEAVE_SUMMARY: "ems/dashboard/employee/leave-summary",
      ATTENDANCE_SUMMARY: "ems/dashboard/employee/attendance/overview"
    },
    ATTENDANCE_REPORT: {
      GET_BY_LIST: "ems/attendance",
      GET_TEAM_REPORT: "ems/attendance/team-report"
    },
    ATTENDANCE_LOG: "ems/attendance/log",
    EDIT_PROFILE: {
      UPDATE: "ems/editprofile/employee/update",
      GET_BY_ID: "ems/editprofile/employee/getById",
      UPLOAD_PROFILE_IMAGE: "ems/editprofile/employee/upload"
    },
    DEPARTMENT: {
      GET_BY_LIST: "ems/department",
      UPDATE_STATUS: "ems/department/updateStatus/",
      CREATE: "ems/department/create",
      UPDATE: "ems/department/update",
      GET_BY_ID: "ems/department/getById"
    },
    ONBOARDING: {
      GET_BY_LIST: "ems/employees/details",
      UPDATE_STATUS: "ems/employees/details/updateStatus/",
      CREATE: "ems/employees/details/create",
      UPDATE: "ems/employees/details/update",
      GET_BY_ID: "ems/employees/details/getById"
    },
    TIMECARD: {
      GET_BY_LIST_TO_APPROVE: "ems/employees/timecard/approval-list",
      GET_BY_LIST: "ems/employees/timecard",
      UPDATE_STATUS: "ems/employees/timecard/updateStatus/",
      CREATE: "ems/employees/timecard/create",
      GET_BY_ID: "ems/employees/timecard/getById"
    },
    OFFICE_LOCATIONS: {
      GET_BY_LIST: "ems/office/locations",
      UPDATE_STATUS: "ems/office/locations/updateStatus/",
      CREATE: "ems/office/locations/create",
      UPDATE: "ems/office/locations/update",
      GET_BY_ID: "ems/office/locations/getById"
    },
    OFFICE_LOCATION_MAPPING: {
      GET_BY_LIST: "ems/office/location/mapping",
      UPDATE_STATUS: "ems/office/location/mapping/updateStatus/",
      CREATE: "ems/office/location/mapping/create",
      UPDATE: "ems/office/location/mapping/update",
      GET_BY_ID: "ems/office/location/mapping/getById"
    },
    LEAVE_TYPE: {
      GET_BY_LIST: "ems/leave/types",
      UPDATE_STATUS: "ems/leave/types/updateStatus/",
      CREATE: "ems/leave/types/create",
      UPDATE: "ems/leave/types/update",
      GET_BY_ID: "ems/leave/types/getById"
    },
    LEAVE_APPLICATION: {
      GET_BY_LIST: "ems/leave/application",
      UPDATE_STATUS: "ems/leave/application/updateStatus/",
      CREATE: "ems/leave/application/create",
      UPDATE: "ems/leave/application/update",
      GET_BY_ID: "ems/leave/application/getById",
      GET_LEAVE_BALANCES: "ems/leave/application/getLeaveBalance",
      GET_BY_LIST_TO_APPROVE: "ems/leave/application/approval-list"
    },
    PUBLIC_HOLIDAY: {
      GET_BY_LIST: "ems/public-holidays",
      UPDATE_STATUS: "ems/public-holidays/updateStatus/",
      CREATE: "ems/public-holidays/create",
      UPDATE: "ems/public-holidays/update",
      GET_BY_ID: "ems/public-holidays/getById"
    }
  },
  ASSET_MANAGEMENT_PORTAL: {
    DROPDOWN_SERVICE: {
      GET_INV_GROUPS: "inv/dropdowns/getGroup",
      GET_INV_SUB_GROUPS: "inv/dropdowns/getSubGroup",
      GET_RAM: "inv/dropdowns/getRam",
      GET_OS: "inv/dropdowns/getOs",
      GET_MAIL_CONFIG: "inv/dropdowns/getMailConfig",
      GET_ASSET_ID: "inv/dropdowns/getAssetId",
      GET_ASSET_TYPE: "inv/dropdowns/getAssetType",
      GET_ASSET_CATEGORY: "inv/dropdowns/getCategory",
      GET_ASSET_STATE: "inv/dropdowns/getAssetState",
      GET_ASSET_PROCESSOR: "inv/dropdowns/getProcessor",
      GET_SERVER_ZONES: "inv/dropdowns/getServerZone"
    },
    SCHEMA_TABLE: {
      CREATE: "inv/api/table/create"
    },
    HDD: {
      GET_BY_LIST: "inv/harddisk",
      UPDATE_STATUS: "inv/harddisk/updateStatus/",
      CREATE: "inv/harddisk/create",
      UPDATE: "inv/harddisk/update",
      GET_BY_ID: "inv/harddisk/getById"
    },
    OS: {
      GET_BY_LIST: "inv/os",
      UPDATE_STATUS: "inv/os/updateStatus/",
      CREATE: "inv/os/create",
      UPDATE: "inv/os/update",
      GET_BY_ID: "inv/os/getById"
    },
    GROUPS: {
      GET_BY_LIST: "inv/inv-groups",
      UPDATE_STATUS: "inv/inv-groups/updateStatus/",
      CREATE: "inv/inv-groups/create",
      UPDATE: "inv/inv-groups/update",
      GET_BY_ID: "inv/inv-groups/getById"
    },
    SUB_GROUPS: {
      GET_BY_LIST: "inv/sub-groups",
      UPDATE_STATUS: "inv/sub-groups/updateStatus/",
      CREATE: "inv/sub-groups/create",
      UPDATE: "inv/sub-groups/update",
      GET_BY_ID: "inv/sub-groups/getById"
    },
    PROCESSOR: {
      GET_BY_LIST: "inv/processor",
      UPDATE_STATUS: "inv/processor/updateStatus/",
      CREATE: "inv/processor/create",
      UPDATE: "inv/processor/update",
      GET_BY_ID: "inv/processor/getById"
    },
    RAM: {
      GET_BY_LIST: "inv/ram",
      UPDATE_STATUS: "inv/ram/updateStatus/",
      CREATE: "inv/ram/create",
      UPDATE: "inv/ram/update",
      GET_BY_ID: "inv/ram/getById"
    },
    CATEGORY: {
      GET_BY_LIST: "inv/category",
      UPDATE_STATUS: "inv/category/updateStatus/",
      CREATE: "inv/category/create",
      UPDATE: "inv/category/update",
      GET_BY_ID: "inv/category/getById"
    },
    ASSETS: {
      GET_BY_LIST: "inv/manageassets",
      UPDATE_STATUS: "inv/manageassets/updateStatus/",
      CREATE: "inv/manageassets/create",
      UPDATE: "inv/manageassets/update",
      GET_BY_ID: "inv/manageassets/getById",
      UPLOAD_CSV: "inv/manageassets/bulk-insert",
      CHECK_DUPLICATE: "inv/manageassets/check-duplicate"
    },
    VM_REQUESTS: {
      GET_BY_LIST: "inv/vm-request",
      UPDATE_STATUS: "inv/vm-request/updateStatus/",
      CREATE: "inv/vm-request/create",
      UPDATE: "inv/vm-request/update",
      GET_BY_ID: "inv/vm-request/getById",
      UPLOAD_CSV: "inv/vm-request/bulk-insert",
      GET_BY_LIST_TO_APPROVE: "inv/vm-request/approval-list"
    },
    WARRENTY: {
      CHECK: ""
    },
    MASTER_ASSETS: {
      GET_BY_LIST: "inv/core/assets",
      UPDATE_STATUS: "inv/core/assets/updateStatus/",
      CREATE: "inv/core/assets/create",
      UPDATE: "inv/core/assets/update",
      GET_BY_ID: "inv/core/assets/getById",
      SEARCH: "inv/core/assets/search"
    },
    SERVERS: {
      GET_BY_LIST: "inv/manageserver",
      UPDATE_STATUS: "inv/manageserver/updateStatus/",
      CREATE: "inv/manageserver/create",
      UPDATE: "inv/manageserver/update",
      GET_BY_ID: "inv/manageserver/getById",
      UPLOAD_CSV: "inv/manageserver/bulk-insert",
      GET_CAPACITY_PLANNING: "inv/manageserver/getCapacityPlanning",
      GET_HOST_AND_VM_LIST: "inv/manageserver/getCompleteVMAndHost",
      CHECK_DUPLICATE: "inv/manageserver/check-duplicate"
    },
    AUDIT: {
      GET_BY_LIST: "inv/assets/audit",
      UPDATE_STATUS: "inv/assets/audit/updateStatus/",
      CREATE: "inv/assets/audit/create",
      UPDATE: "inv/assets/audit/update",
      GET_BY_ID: "inv/assets/audit/getById",
      CONDUCT_AUDIT: "inv/assets/audit/conduct-all",
      COMPLETE: "inv/assets/audit/complete/"
    },
    ASSETTYPE: {
      GET_BY_LIST: "inv/asset-type",
      UPDATE_STATUS: "inv/asset-type/updateStatus/",
      CREATE: "inv/asset-type/create",
      UPDATE: "inv/asset-type/update",
      GET_BY_ID: "inv/asset-type/getById"
    }
  },
  IT_CHANGE_MANAGEMENT_PORTAL: {
    CHANGE_REQUEST: {
      GET_BY_LIST: "itcms/it-change-request",
      UPDATE_STATUS: "itcms/it-change-request/updateStatus/",
      CREATE: "itcms/it-change-request/create",
      UPDATE: "itcms/it-change-request/update",
      GET_BY_ID: "itcms/it-change-request/getById",
      GET_BLOB: "itcms/it-change-request/getBlob",
      STATUS_COUNT: "itcms/it-change-request/status-count"
    },
    IMPLEMENTOR: {
      GET_BY_LIST: "itcms/request/implementor",
      UPDATE_STATUS: "itcms/request/implementor/updateStatus/",
      CREATE: "itcms/request/implementor/create",
      UPDATE: "itcms/request/implementor/update",
      GET_BY_ID: "itcms/request/implementor/getById",
      DELETE: "itcms/request/implementor"
    },
    APPROVAL: {
      GET_BY_LIST: "itcms/approval",
      UPDATE_STATUS: "itcms/approval/updateStatus/",
      CREATE: "itcms/approval/create",
      UPDATE: "itcms/approval/update",
      GET_BY_ID: "itcms/approval/getById",
      DELETE: "itcms/approval"
    },
    IMPLEMENTATION_LOGS: {
      GET_BY_LIST: "itcms/implementationlog",
      UPDATE_STATUS: "itcms/implementationlog/updateStatus/",
      CREATE: "itcms/implementationlog/create",
      UPDATE: "itcms/implementationlog/update",
      GET_BY_ID: "itcms/implementationlog/getById",
      DELETE: "itcms/implementationlog"
    }
  },
  ASSET_DISPOSAL_MANAGEMENT_SYSTEM: {
    DASHBOARD: {
      GET_STATS: "adms/dashboard/stats",
      GET_DISPOSAL_TYPES: "adms/dashboard/disposal-types",
      GET_DEPARTMENT_WORKLOAD: "adms/dashboard/department-workload",
      GET_RECENT_ACTIVITY: "adms/dashboard/recent-activity"
    },
    REQUEST: {
      GET_BY_LIST: "adms/request",
      UPDATE_STATUS: "adms/request/updateStatus/",
      CREATE: "adms/request/create",
      UPDATE: "adms/request/update",
      GET_BY_ID: "adms/request/getById",
      UPLOAD_CSV: "adms/request/bulk-insert",
      GET_BY_LIST_TO_APPROVE: "adms/request/approval-list",
      GET_BLOB: "adms/request/getBlob",
      PERFORM_ACTION: "adms/request/perform-action",
      STATUS_COUNT: "adms/request/status-count"
    },
    WORKFLOW_STAGE: {
      GET_BY_LIST: "adms/workflow/stages",
      GET_BY_ID: "adms/workflow/stages/getById",
      GET_CURRENT_STAGE: "adms/workflow/stages/current-stage"
    }
  },
  BILLING_SERVICE: {
    PAYMENT_GATEWAY_CONFIG: {
      GET_BY_LIST: "api/billing/payment-gateway-config",
      UPDATE_STATUS: "api/billing/payment-gateway-config/updateStatus/",
      CREATE: "api/billing/payment-gateway-config/create",
      UPDATE: "api/billing/payment-gateway-config/update",
      GET_BY_ID: "api/billing/payment-gateway-config/getById"
    }
  },
  HEALTH_CARE_PORTAL: {
    COMMAND_CENTER: {
      ADMIN_DASHBOARD: "patients/api/admin/dashboard",
      OP_DASHBOARD: "patients/api/v1/dashboard/op",
      OP_BILLING_DASHBOARD: "api/v1/billing/dashboard/op"
    },
    DROPDOWN_SERVICE: {
      GET_STATES: "patients/registration/states",
      GET_COUNCILS: "doctors/dropdowns/getMedicalCouncil",
      GET_YEARS: "patients/registration/years",
      GET_MEDICAL_DEPARTMENTS: "doctors/dropdowns/getMedicalDepartments"
    },
    PATIENT: {
      PATIENT_REGISTRATION: {
        GET_BY_LIST: "patients",
        UPDATE_STATUS: "patients/updateStatus/",
        CREATE: "patients/create",
        UPDATE: "patients/update",
        GET_BY_ID: "patients/getById",
        FIND_SIMILAR: "patients/findSimilar",
        PATIENT_SEARCH: "patients/search"
      },
      ABHA: {
        STATUS: "patients/abha",
        REQUEST_OTP: "patients/abha",
        VERIFY: "patients/abha"
      },
      PATIENT_VISIT: {
        GET_BY_LIST: "patients/visits",
        DOCTOR_SCOPE: "patients/visits/doctor-scope",
        UPDATE_STATUS: "patients/visits/updateStatus/",
        CREATE: "patients/visits/create",
        FORCE_CREATE: "patients/visits/force-create",
        UPDATE: "patients/visits/update",
        GET_BY_ID: "patients/visits/getById",
        DELETE: "patients/visits",
        FOLLOWUP: "patients/visits/followup",
        /** Base: patients/visits/{visitId}/attachments… */
        ATTACHMENTS: "patients/visits"
      },
      PUBLIC_TOKEN: {
        CATALOG: "patients/public/token/catalog",
        REGISTER: "patients/public/token/register"
      },
      PATIENT_TOKEN: {
        GET_BY_LIST: "patients/patient-token",
        UPDATE_STATUS: "patients/patient-token/updateStatus/",
        CREATE: "patients/patient-token/create",
        UPDATE: "patients/patient-token/update",
        GET_BY_ID: "patients/patient-token/getById"
      },
      PATIENT_VITALS: {
        GET_BY_LIST: "patients/opd/vitals",
        UPDATE_STATUS: "patients/opd/vitals/updateStatus/",
        CREATE: "patients/opd/vitals/create",
        UPSERT: "patients/opd/vitals/upsert",
        UPDATE: "patients/opd/vitals/update",
        GET_BY_ID: "patients/opd/vitals/getById",
        DELETE: "patients/opd/vitals",
        HISTORY: "patients/opd/vitals/history",
        INTELLIGENCE: "patients/opd/vitals/intelligence"
      },
      PATIENT_ALLERGIES: {
        LIST: "patients/opd/allergies",
        CREATE: "patients/opd/allergies/create",
        UPDATE: "patients/opd/allergies/update",
        CONFIRM: "patients/opd/allergies/confirm",
        DEACTIVATE: "patients/opd/allergies/deactivate",
        ASSERT_NKA: "patients/opd/allergies/assert-nka"
      },
      CONSULTATION_CONTEXT: "patients/opd/consultation-context",
      CLINICAL_DOCUMENTATION: "patients/opd/clinical-documentation",
      PATIENT_COMPLAINTS: {
        GET_BY_LIST: "patients/opd/complaints",
        UPDATE_STATUS: "patients/opd/complaints/updateStatus/",
        CREATE: "patients/opd/complaints/create",
        UPSERT: "patients/opd/complaints/upsert",
        UPSERT_BULK: "patients/opd/complaints/upsert/bulk",
        UPDATE: "patients/opd/complaints/update",
        GET_BY_ID: "patients/opd/complaints/getById"
      },
      PATIENT_DIAGNOSIS: {
        GET_BY_LIST: "patients/opd/diagnosis",
        UPDATE_STATUS: "patients/opd/diagnosis/updateStatus/",
        CREATE: "patients/opd/diagnosis/create",
        UPSERT: "patients/opd/diagnosis/upsert",
        UPSERT_BULK: "patients/opd/diagnosis/upsert/bulk",
        UPDATE: "patients/opd/diagnosis/update",
        GET_BY_ID: "patients/opd/diagnosis/getById",
        SEARCH: "patients/opd/diagnosis/search"
      },
      PATIENT_NOTES: {
        GET_BY_LIST: "patients/opd/notes",
        UPDATE_STATUS: "patients/opd/notes/updateStatus/",
        CREATE: "patients/opd/notes/create",
        UPSERT: "patients/opd/notes/upsert",
        UPSERT_BULK: "patients/opd/notes/upsert/bulk",
        UPDATE: "patients/opd/notes/update",
        GET_BY_ID: "patients/opd/notes/getById"
      },
      OPD_PRESCRIPTION: {
        GET_BY_LIST: "patients/opd/rx",
        UPDATE_STATUS: "patients/opd/rx/updateStatus/",
        CREATE: "patients/opd/rx/create",
        UPSERT: "patients/opd/rx/upsert",
        UPSERT_BULK: "patients/opd/rx/upsert/bulk",
        UPDATE: "patients/opd/rx/update",
        GET_BY_ID: "patients/opd/rx/getById"
      },
      OPD_INVESTIGATIONS: {
        GET_BY_LIST: "patients/opd-investigations",
        UPDATE_STATUS: "patients/opd-investigations/updateStatus/",
        CREATE: "patients/opd-investigations/create",
        UPSERT: "patients/opd-investigations/upsert",
        UPSERT_BULK: "patients/opd-investigations/upsert/bulk",
        UPDATE: "patients/opd-investigations/update",
        GET_BY_ID: "patients/opd-investigations/getById"
      },
      OPD_PRESCRIPTION_ITEM: {
        GET_BY_LIST: "patients/opd/rx-items",
        UPDATE_STATUS: "patients/opd/rx-items/updateStatus/",
        CREATE: "patients/opd/rx-items/create",
        UPSERT: "patients/opd/rx-items/upsert",
        UPSERT_BULK: "patients/opd/rx-items/upsert/bulk",
        UPDATE: "patients/opd/rx-items/update",
        GET_BY_ID: "patients/opd/rx-items/getById"
      }
    },
    DOCTOR_MANAGEMENT: {
      USER_LINK: {
        RESOLVE: "doctors/user-link/resolve",
        UPSERT: "doctors/user-link/upsert",
        REMOVE: "doctors/user-link/remove"
      },
      USER_LINKS: {
        AUTO_RESOLVE: "doctors/user-links/auto-resolve",
        RECONCILE: "doctors/user-links/reconcile"
      },
      DOCTOR_DETAILS: {
        GET_BY_LIST: "doctors/onboard",
        UPDATE_STATUS: "doctors/onboard/updateStatus/",
        CREATE: "doctors/onboard/create",
        UPDATE: "doctors/onboard/update",
        GET_BY_ID: "doctors/onboard/getById"
      },
      CREDENTIALS: {
        GET_BY_LIST: "doctors/credentials",
        UPDATE_STATUS: "doctors/credentials/updateStatus/",
        CREATE: "doctors/credentials/create",
        UPDATE: "doctors/credentials/update",
        GET_BY_ID: "doctors/credentials/getById",
        GET_BLOB: "doctors/credentials/getBlob",
        PRESIGNED_URL: "doctors/credentials/presigned-url",
        SEARCH: "doctors/credentials/search"
      },
      HOSPITAL_ASSOCIATION: {
        GET_BY_LIST: "doctors/hospital-association",
        UPDATE_STATUS: "doctors/hospital-association/updateStatus/",
        CREATE: "doctors/hospital-association/create",
        UPDATE: "doctors/hospital-association/update",
        GET_BY_ID: "doctors/hospital-association/getById",
        GET_BY_DOCTOR: "doctors/hospital-association/doctor-hospital",
        GET_AVAILABLE_DOCTORS: "doctors/hospital-association/available-doctors"
      },
      SCHEDULE: {
        GET_BY_LIST: "doctors/doctor-schedule",
        UPDATE_STATUS: "doctors/doctor-schedule/updateStatus/",
        CREATE: "doctors/doctor-schedule/create",
        UPDATE: "doctors/doctor-schedule/update",
        GET_BY_ID: "doctors/doctor-schedule/getById"
      },
      SIGNATURE: {
        GET_BY_LIST: "doctors/signature",
        UPDATE_STATUS: "doctors/signature/updateStatus/",
        CREATE: "doctors/signature/create",
        UPDATE: "doctors/signature/update",
        GET_BY_ID: "doctors/signature/getById",
        GET_BLOB: "doctors/signature/getBlob",
        PRESIGNED_URL: "doctors/signature/presigned-url"
      }
    }
  }
};
export default apiPaths;
